import { Stack } from "@shopify/polaris";
import {
  UPDATES_FREQUENCY_EVERY_PERIOD,
  UPDATES_FREQUENCY_EVERY_SCHEDULED
} from "../../../../../../../../constants/updatesFrequencyTypes.js";
import EveryPeriodSettings from "./EveryPeriodSettings/EveryPeriodSettings.js";
import UpdatesFrequencyTypeButtons from "./UpdatesFrequencyTypeButtons.js";
import ScheduledSettings from "./ScheduledSettings/ScheduledSettings.js";

const UpdatesFrequencyFields = ({ input }) => {
  return (
    <Stack distribution={"fill"}>
      <UpdatesFrequencyTypeButtons input={input} />
      {input.value.type === UPDATES_FREQUENCY_EVERY_PERIOD && <EveryPeriodSettings input={input} />}
      {input.value.type === UPDATES_FREQUENCY_EVERY_SCHEDULED && <ScheduledSettings input={input} />}
    </Stack>

  );
};

export default UpdatesFrequencyFields;